import { SurveyReferenceQuestionProps } from './referenceTypes';
import { SurveyReferenceQuestion } from './SurveyReferenceQuestion';

export const SurveyTopLevelReferenceQuestion = ({
  question,
  answer,
  readonly,
  value,
  hasSubQuestions,
  survey,
  componentId,
  fields,
  currentLocale,
  i18nLocale,
  hasAttemptedSubmission,
  hasAutocompleteFeature,
  hasReferenceSuggestionsFeature,
  hasEditableReferencesInQuestionsFeature,
  noAccessReferences,
  isEmbedded,
  hideReadOnlyLabel,
  highlightUnansweredPriorityQuestions,
  setAnswer,
  addNestedAnswer,
  setNestedAnswer,
  removeNestedAnswer,
  updateReferenceComponent,
  getDuplicate,
  getExistingComponentByName,
  generateComponentDescription,
  trackDescriptionGenerated,
  trackDescriptionGeneratedFailed,
  trackCreatedReferenceFromQuestion,
  getAISuggestions,
  fetchComponentOptionsWithQuery,
  userOptions,
  QuestionContentWrapper,
}: SurveyReferenceQuestionProps) => {
  return (
    <SurveyReferenceQuestion
      userOptions={userOptions}
      question={question}
      answer={answer}
      value={value}
      survey={survey}
      hasSubQuestions={hasSubQuestions}
      componentId={componentId}
      readonly={readonly}
      fields={fields}
      currentLocale={currentLocale}
      i18nLocale={i18nLocale}
      hasAttemptedSubmission={hasAttemptedSubmission}
      hasAutocompleteFeature={hasAutocompleteFeature}
      hasReferenceSuggestionsFeature={hasReferenceSuggestionsFeature}
      hasEditableReferencesInQuestionsFeature={
        hasEditableReferencesInQuestionsFeature
      }
      noAccessReferences={noAccessReferences}
      isEmbedded={isEmbedded}
      hideReadOnlyLabel={hideReadOnlyLabel}
      highlightUnansweredPriorityQuestions={
        highlightUnansweredPriorityQuestions
      }
      addNestedAnswer={addNestedAnswer}
      removeNestedAnswer={removeNestedAnswer}
      setAnswer={setAnswer}
      setNestedAnswer={setNestedAnswer}
      updateReferenceComponent={updateReferenceComponent}
      getDuplicate={getDuplicate}
      getExistingComponentByName={getExistingComponentByName}
      trackDescriptionGenerated={trackDescriptionGenerated}
      trackDescriptionGeneratedFailed={trackDescriptionGeneratedFailed}
      trackCreatedReferenceFromQuestion={trackCreatedReferenceFromQuestion}
      getAISuggestions={getAISuggestions}
      fetchComponentOptionsWithQuery={fetchComponentOptionsWithQuery}
      generateComponentDescription={generateComponentDescription}
      QuestionContentWrapper={QuestionContentWrapper}
    />
  );
};
